import React, { Fragment, useState, useEffect } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileAlt, faTrashAlt, faCheckCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import AlertModal from '../../../shared/components/Modal';
import moment from 'moment';
import 'moment-timezone';

const UserDocumentsTableActions = ({ data, onShowDocument, Callback, idTeamInvestorMember }) => {
    const documentData = data.data.original;
    const [alertModalWarning, setAlertModalWarning] = useState(false);
    const [alertModalSuccess, setAlertModalSuccess] = useState(false);
    const [alertModalError, setAlertModalError] = useState(false);
    const [alertModalSuccess2, setAlertModalSuccess2] = useState(false);
    const [alertModalError2, setAlertModalError2] = useState(false);
    const [alertModalSuccess3, setAlertModalSuccess3] = useState(false);

    let url = process.env.REACT_APP_PUBLIC_URL + documentData.url_documento + "/" + sessionStorage.getItem('token');

    useEffect(() => {

    }, []);

    const downloadDocument = async () => {

        console.log("URL",url);
        onShowDocument(url, documentData.documento);
    }

    const deleteDocument = async () => {
        setAlertModalWarning(false);
        let dataSend = {
            id_usu_doc: documentData.id_usu_doc
        }
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'docs-usuario/delete', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                setAlertModalSuccess(true);
            }
            else {
                throw new Error(response.message);
            }
        }).catch((error) => {
            setAlertModalError(true);
            console.error('Error:', error);
        });
    }

    const vinculateClinicalStudie = async () => {
        let dataSend = {
            id_equipo_inv: idTeamInvestorMember,
            id_usu_doc: data.data.original.id_usu_doc,
            fecha: moment().tz("America/Bogota").format("YYYY-MM-DD HH:mm:ss"),
            activo_estudio: true
        }
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'estudio-entrenamiento/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                setAlertModalSuccess2(true);
            }
            else {
                throw new Error(response.message);
            }
        }).catch((error) => {
            setAlertModalError2(true);
            console.error('Error:', error);
        });
    }

    const unlinkClinicalStudie = async () => {
        let dataSend = {
            id_entrenamiento: data.data.original.id_entrenamiento
        }
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'estudio-entrenamiento/delete', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataSend)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                setAlertModalSuccess3(true);
            }
            else {
                throw new Error(response.message);
            }
        }).catch((error) => {
            setAlertModalError2(true);
            console.error('Error:', error);
        });
    }

    return (<Fragment>
        <td role="cell">
            <Tooltip title="Revisar Documento">
                <IconButton style={{ fontSize: '20px' }} onClick={() => {
                    downloadDocument();
                }}>
                    <FontAwesomeIcon icon={faFileAlt} />
                </IconButton>
            </Tooltip>
            {
                idTeamInvestorMember != null ? <>
                    {
                        data.data.original.id_entrenamiento != null && data.data.original.id_entrenamiento != undefined ?

                            <Tooltip title="Desvincular del Estudio Clinico">
                                <IconButton className="text-danger" style={{ fontSize: '20px' }} onClick={() => {
                                    unlinkClinicalStudie();
                                }}>
                                    <FontAwesomeIcon icon={faTimesCircle} />
                                </IconButton>
                            </Tooltip>
                            : <Tooltip title="Vincular al Estudio Clinico">
                                <IconButton style={{ fontSize: '20px' }} onClick={() => {
                                    vinculateClinicalStudie();
                                }}>
                                    <FontAwesomeIcon icon={faCheckCircle} />
                                </IconButton>
                            </Tooltip>
                    }
                </>
                    : <>
                        <Tooltip title="Eliminar Documento">
                            <IconButton style={{ fontSize: '20px' }} onClick={() => {
                                setAlertModalWarning(true);
                            }}>
                                <FontAwesomeIcon icon={faTrashAlt} />
                            </IconButton>
                        </Tooltip>
                    </>
            }
        </td>

        <AlertModal
            color="warning"
            title="Esta seguro que desea eliminar este documento del sistema?"
            modal={alertModalWarning}
            onOk={() => deleteDocument()}
            toggle={() => setAlertModalWarning(false)}
        />

        <AlertModal
            color="danger"
            title="Este documento no se puede eliminar, es posible que se utilice en otros procesos internos"
            modal={alertModalError}
            onOk={() => setAlertModalError(false)}
            toggle={() => setAlertModalError(false)}
        />

        <AlertModal
            color="success"
            title="Documento eliminado exitosamente"
            modal={alertModalSuccess}
            onOk={() => {
                setAlertModalSuccess(false);
                Callback();
            }}
            toggle={() => setAlertModalSuccess(false)}
        />

        <AlertModal
            color="success"
            title="Documento vinculado exitosamente"
            modal={alertModalSuccess2}
            onOk={() => {
                setAlertModalSuccess2(false);
                Callback();
            }}
            toggle={() => setAlertModalSuccess2(false)}
        />

        <AlertModal
            color="danger"
            title="Ha ocurrido un error en el sistema"
            modal={alertModalError2}
            onOk={() => setAlertModalError2(false)}
            toggle={() => setAlertModalError2(false)}
        />

        <AlertModal
            color="success"
            title="Documento desvinculado exitosamente"
            modal={alertModalSuccess3}
            onOk={() => {
                setAlertModalSuccess3(false);
                Callback();
            }}
            toggle={() => setAlertModalSuccess3(false)}
        />

    </Fragment>)
}

export default UserDocumentsTableActions;